import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
  useCallback,
  useMemo,
} from "react";
import { useParams } from "react-router";
import GiftDetailsIncludeFields from "./GiftDetailsIncludeFields.component";
import SnackbarUtils from "../../../../../../../libs/SnackbarUtils";
const TEMP_OBJ = {
  title: "",
  reward: "",
  required_points: "",
  extra_points: "",
  is_checked: "",
};

const GiftDetailsIncludeForm = (
  { data, errorData: errorForm, isSidePanel, updateTableData, setForm },
  ref
) => {
  const [fields, setFields] = useState([JSON.parse(JSON.stringify(TEMP_OBJ))]);
  const [errorData, setErrorData] = useState({});
  const [variants, setVariants] = useState([]);
  const { id } = useParams();
  console.log("first", data)
  useImperativeHandle(ref, () => ({
    isValid() {
      return validateData();
    },
    resetData() {
      setFields([JSON.parse(JSON.stringify(TEMP_OBJ))]);
    },
    getData() {
      return fields;
    },
    setData(data) {
      console.log("setData => ", data);
      setFields([...data]);
    },
  }));

  useEffect(() => {
    if (!isSidePanel) {
      setErrorData({});
    }
  }, [isSidePanel]);

  useEffect(() => {
    if (data?.length > 0) {
      setFields([...data]);
    }
  }, [data]);

  const validateData = (index, type) => {
    const errors = {};
    fields.forEach((val, index) => {
      const err = {};
      const required = ["required_points"];

      required.forEach((key) => {
        if (!val[key] || val[key] === "" || parseFloat(val[key]) <= 0) {
          err[key] = true;
        }
      });
      if (Object.keys(err).length > 0) {
        errors[index] = err;
        if (val.required_points === "-") {
          errors.required_points = true;
          SnackbarUtils.error("Required points field is required");
        }
      } 
    });

    setErrorData(errors);
   
    return Object.keys(errors).length === 0;
  };

  const removeErrors = useCallback(
    (index, key) => {
      const errors = JSON.parse(JSON.stringify(errorData));
      if (errors[index] != undefined) {
        if (Array.isArray(key)) {
          key.forEach((k) => {
            delete errors[index][k];
          });
        } else {
          delete errors[index][key];
        }
        setErrorData(errors);
      }
    },
    [setErrorData, errorData]
  );

  const changeData = (index, data) => {
    const tempData = [...fields];

    tempData[index] = { ...tempData[index], ...data };
    updateTableData(tempData);
    const errArr = [];
    Object.keys(data).forEach((key) => {
      errArr.push(key);
    });
    removeErrors(index, errArr);
  };

  const onBlur = useCallback(() => {}, []);
  const handlePress = async (type, index = 0) => {
    const oldState = [...fields];
    if (type == "ADDITION") {
      oldState.push(TEMP_OBJ);
    } else {
      if (oldState.length === 1) {
        return true;
      }
      oldState.splice(index, 1);
    }
    setFields(oldState);
    // validateData();
  };
  const renderFields = useMemo(() => {
    return fields?.map((val, index) => {
      const tempFilters = variants.filter((variant) => {
        const index = fields?.findIndex(
          (val) => val?.sku?.sku === variant?.sku
        );
        return index < 0;
      });
      return (
        <div>
          <GiftDetailsIncludeFields
            variants={tempFilters}
            validateData={validateData}
            errors={index in errorData ? errorData[index] : null}
            changeData={changeData}
            handlePress={handlePress}
            data={val}
            index={index}
            onBlur={onBlur}
            fieldLendth={fields?.length}
            setForm={setForm}
          />
        </div>
      );
    });
  }, [
    variants,
    errorData,
    validateData,
    changeData,
    handlePress,
    onBlur,
    fields,
    isSidePanel,
    setErrorData,
    data,
  ]);

  return <>{renderFields}</>;
};

export default forwardRef(GiftDetailsIncludeForm);
